<template>
  <div class="v2026-ec" :class="{ 'v2026-ec--card': variant === 'card' }">
    <img class="v2026-ec__avatar" :src="avatarUrl" alt="" @error="onAvatarError">
    <div class="v2026-ec__text">
      <div class="v2026-ec__name">{{ displayName }}</div>
      <div class="v2026-ec__meta">{{ idLabel }} <a :href="idHref" target="_blank">{{ idValue }}</a></div>
      <div class="v2026-ec__tags" v-if="tags.length">
        <span class="v2026-ec__tag" v-for="tag in tags" :key="tag">{{ tag }}</span>
      </div>
    </div>
    <!-- Optional buttons between the text and the chevron (e.g. the account "switch"). -->
    <slot name="actions"></slot>
    <a :href="idHref" target="_blank">
      <span class="v2026-ec__mask v2026-ec__chevron" aria-hidden="true"
          :style="maskStyle(chevronIcon)"></span>
    </a>
  </div>
</template>

<script>
const CHEVRON_RIGHT = require('@/assets/icons2026/chevron-right.svg')
const PLACEHOLDER_AVATAR = 'https://beneat.co/static/img/unknown.png'

export default {
  name: 'entity-card-v2026',
  props: {
    // 'card' = standalone card (own background + radius); 'row' = inside a list wrapper that
    // owns those, plus a divider between rows.
    variant: {
      type: String,
      default: 'row',
      validator: v => ['card', 'row'].includes(v)
    },
    avatarUrl: {
      type: String,
      default: ''
    },
    // default null, NOT '-': Vue only substitutes a default for `undefined`, and every parent
    // already owns its own '-' fallback.
    displayName: {
      type: String,
      default: null
    },
    idLabel: {
      type: String,
      default: 'User ID:'
    },
    idValue: {
      type: [Number, String],
      default: null
    },
    idHref: {
      type: String,
      default: null
    },
    // Optional small chips under the id line (e.g. why this account was listed).
    tags: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chevronIcon: CHEVRON_RIGHT
    }
  },
  methods: {
    // Swap to the placeholder if the avatar fails; guarded against a fallback loop.
    onAvatarError (e) {
      if (e && e.target && e.target.src !== PLACEHOLDER_AVATAR) {
        e.target.src = PLACEHOLDER_AVATAR
      }
    },
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-ec {
  --v2026-ec-surface-sunken: #F8FAFC;
  --v2026-ec-surface-hover: #e9ecf1;
  --v2026-ec-border: #e4e7ec;
  --v2026-ec-text: #101828;
  --v2026-ec-text-muted: #98a2b3;
  --v2026-ec-icon: #475467;

  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  transition: background 150ms ease;
}

.v2026-ec--card {
  background: var(--v2026-ec-surface-sunken);
  border-radius: 12px;
}

.v2026-ec + .v2026-ec {
  border-top: 1px solid var(--v2026-ec-border);
}

.v2026-ec:hover {
  background: var(--v2026-ec-surface-hover);
}

.v2026-ec__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
}

.v2026-ec__text {
  flex: 1;
  min-width: 0;
}
.v2026-ec__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--v2026-ec-text);
}
.v2026-ec__meta {
  font-size: 12px;
  color: var(--v2026-ec-text-muted);
}

.v2026-ec__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.v2026-ec__tag {
  padding: 1px 6px;
  border: 1px solid var(--v2026-ec-border);
  border-radius: 6px;
  background: #ffffff;
  font-size: 11px;
  line-height: 16px;
  color: var(--v2026-ec-icon);
}

.v2026-ec__mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-ec-icon);
}

.v2026-ec__chevron {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  background-color: var(--v2026-ec-icon);
}
</style>
